import React from "react";
import { cn } from "@/lib/utils";
import { Download } from "lucide-react";

export default function PageHeader({ title, subtitle, actions, className, onDownload }) {
  return (
    <div className={cn("flex flex-col gap-3 md:flex-row md:items-center md:justify-between animate-page-enter", className)}>
      <div className="space-y-1">
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        {onDownload && (
          <button
            onClick={onDownload}
            className="inline-flex items-center gap-1.5 rounded-lg border border-stone-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 shadow-sm transition-all hover:border-stone-300 hover:bg-stone-100 hover:text-slate-900"
          >
            <Download size={13} strokeWidth={2} /> Download Report
          </button>
        )}
        {actions}
      </div>
    </div>
  );
}
